import React, { HtmlHTMLAttributes } from 'react';

import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';

import {
  ActionButton,
  ActionsRow,
  Container,
  ContainerContent,
  DateLabel,
  DragHandle,
  IconBox,
  Row,
  Subtitle,
  Title,
} from './styles';

interface CardWarningsProps extends HtmlHTMLAttributes<HTMLDivElement> {
  title: string;
  content: string;
  dateLabel?: string;
  functionChangeButton?: () => void;
  functionRemoveButton?: () => void;
  dragHandleProps?: Record<string, unknown>;
  id?: string;
}

const CardWarning = React.forwardRef<HTMLDivElement, CardWarningsProps>(
  (
    {
      title,
      content,
      dateLabel,
      functionChangeButton,
      functionRemoveButton,
      dragHandleProps,
      ...rest
    },
    ref,
  ) => {
    return (
      <Container ref={ref} {...rest}>
        {!!dragHandleProps && (
          <DragHandle type="button" {...dragHandleProps}>
            <Icon name="drag_indicator" size={18} />
          </DragHandle>
        )}

        <Row>
          <IconBox>
            <Icon name="campaign" size={22} color={colors.primary} />
          </IconBox>
          <ContainerContent>
            <Title>{title}</Title>
            <Subtitle>{content}</Subtitle>
            {!!dateLabel && <DateLabel>{dateLabel}</DateLabel>}
          </ContainerContent>
        </Row>

        <ActionsRow>
          <ActionButton type="button" onClick={functionChangeButton}>
            <Icon name="edit" size={18} />
          </ActionButton>
          <ActionButton type="button" danger onClick={functionRemoveButton}>
            <Icon name="delete" size={18} />
          </ActionButton>
        </ActionsRow>
      </Container>
    );
  },
);

CardWarning.displayName = 'CardWarning';

export { CardWarning };
